export default __webpack_public_path__ + "static/media/people-3.cef70b7e.svg";